import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import { squashIdIntoValue } from './utils';

export const fetchBackupLocations = () => {
    return asyncActionCreator(types.BACKUP_LOCATIONS_UPDATED, serverApi.fetchBackupLocations({ take: 500 }),
     json => json.items.map(squashIdIntoValue));   
};

export const addBackupLocation = (backupLocation) => {
    return asyncActionCreator(types.BACKUP_LOCATION_ADDITION_UPDATED, serverApi.addBackupLocation(backupLocation),
        json => ({ ...backupLocation, id: json }));
};

export const requestBackupLocationValidation = (backupLocation) => {
    return asyncActionCreator(types.BACKUP_LOCATION_VALIDATION_REQUESTED, 
        serverApi.requestBackupLocationValidation(backupLocation), json => json);
};


// WEBPACK FOOTER //
// ./src/js/actions/backupLocationActionCreators.js